export default "__VITE_ASSET__DpJOvOXp__"